import type { CodeEditorParams } from "@whilecat/core/tasks/java/params/code-editor-params.js";
import { JavaParamsValidator } from "@whilecat/core/tasks/java/params/validators/java-params-validator.js";
import { isPresent } from "@whilecat/core/utils/objects.js";
import { isNotBlankArray } from "@whilecat/core/utils/string.js";
import { sanityCheck } from "@whilecat/core/utils/validation.js";

export class CodeEditorParamsValidator extends JavaParamsValidator<CodeEditorParams> {
    validate(params: CodeEditorParams) {
        const data = params;

        const stub = data._FIXME_TASK_WITHOUT_SUPPLIER === true;
        sanityCheck(
            isNotBlankArray(data.correctAnswer) || isPresent(data.correctAnswerSupplier) || stub,
            "No correctAnswer or correctAnswerSupplier or was provided",
        );
        if (isPresent(data.correctAnswerSupplier)) {
            sanityCheck(
                isPresent(data.correctAnswerVerifier) || isPresent(data.correctAnswerRegExp),
                "Either correctAnswerVerifier either correctAnswerRegExp must be provided",
            );
        }

        this.basicValidation(params);
    }
}
